import { useResource, useInvalidator } from "@rest-hooks/core";
import { useEffect } from "react";
export const useResourceWithInvalidate = (...args) => {
    const ret = useResource(...args);
    const resourceArgs = Array.isArray(args[0])
        ? args
        : [args];
    for (const [shape, params] of resourceArgs) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useInvalidateOnUnmount(shape, params);
    }
    return ret;
};
export function useInvalidateOnUnmount(shape, params) {
    const invalidate = useInvalidator(shape);
    useEffect(() => () => {
        if (params != null)
            invalidate(params);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [invalidate, params && shape.getFetchKey(params)]);
}
//# sourceMappingURL=useResourceWithInvalidate.js.map